import {ExperimentsBag} from '@wix/wix-experiments'

export interface CommonState {
  siteSettings: SiteSettings
  environment: EnvironmentConfig
  experiments: ExperimentsBag
}

export interface SiteSettingsSettings {
  version?: number
  defaultWidgetType?: string
  firstTimeCompleted?: boolean
  pageEnabled?: boolean
  pagesType?: PagesType
  pageUpgradeShown?: boolean
  upgradePending?: boolean
}

export interface SiteSettings extends wix.events.editor.SiteSettings {
  settings: SiteSettingsSettings
  demo: boolean
}

export interface EnvironmentConfig {
  mobile: boolean
  locale: string
  language: string
  timezone: string
  editor: boolean
  site: boolean
  preview: boolean
}

export enum PagesType {
  DETAILS_PAGE_ENABLED = 1,
  DETAILS_PAGE_DISABLED = 2
}

export enum ModalActions {
  CANCEL = 'CANCEL',
  OK = 'OK',
  OUTSIDE_CLICKED = 'OUTSIDE_CLICKED'
}

export type GetCommonState = () => CommonState
